<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
    <!-- 页面头部 -->
      <div class="list-page-heading">
        <div class="list-page-heading-main">
          <h1 class="text-xl font-semibold text-slate-800">通知管理</h1>
          <p class="text-sm text-slate-500 mt-1">创建和管理系统通知消息</p>
        </div>
        <div class="list-page-heading-actions">
          <button
            @click="openNotificationModal()"
            class="btn-primary"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            发布通知
          </button>
        </div>
      </div>
    </template>

      <!-- 操作按钮 -->
    <div>
      <div class="flex items-center gap-2 mb-4">
        <button
          v-if="selectedList.length > 0"
          @click="handleBatchDelete"
          class="btn-danger-secondary"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          删除选中 ({{ selectedList.length }})
        </button>
      </div>

      <!-- 表格 -->
      <div class="list-page-table-panel">
        <PageFilterBar
          shell-class="filter-bar-shell is-embedded"
          body-class="filter-bar-body is-panel"
          show-refresh
          :refresh-loading="loading"
          @refresh="loadNotifications"
        >
          <el-select v-model="searchForm.type" placeholder="请选择类型" class="form-select form-control-sm filter-bar-field">
            <el-option label="全部类型" value="" />
            <el-option label="审批通知" value="APPROVAL" />
            <el-option label="任务通知" value="TASK" />
            <el-option label="系统通知" value="SYSTEM" />
            <el-option label="自定义通知" value="CUSTOM" />
          </el-select>
          <el-select v-model="searchForm.priority" placeholder="请选择优先级" class="form-select form-control-sm filter-bar-field">
            <el-option label="全部优先级" value="" />
            <el-option label="普通" value="0" />
            <el-option label="重要" value="1" />
            <el-option label="紧急" value="2" />
          </el-select>
          <el-select v-model="searchForm.publishStatus" placeholder="请选择状态" class="form-select form-control-sm filter-bar-field">
            <el-option label="全部状态" value="" />
            <el-option label="草稿" value="0" />
            <el-option label="已发布" value="1" />
          </el-select>
          <template #searchActions>
            <button type="button" @click="handleSearch" class="btn-primary">搜索</button>
            <button type="button" @click="resetSearch" class="btn-secondary">重置</button>
          </template>
        </PageFilterBar>
        <div class="data-table-shell">
          <!-- 加载状态 -->
          <div v-if="loading" class="p-4">
            <div class="space-y-4">
              <div v-for="n in 5" :key="n" class="flex items-center gap-4 p-4 border-b border-slate-100">
                <div class="w-4 h-4 bg-slate-200 rounded"></div>
                <div class="w-20 h-6 bg-slate-200 rounded"></div>
                <div class="flex-1 h-6 bg-slate-200 rounded"></div>
                <div class="w-24 h-6 bg-slate-200 rounded"></div>
              </div>
            </div>
          </div>
          <div v-else class="data-table-scroll">
            <table class="data-table">
              <thead class="data-table-head">
                <tr>
                  <th class="data-table-th text-left w-10">
                <input
                  type="checkbox"
                  v-model="selectAll"
                  @change="handleSelectAll"
                  class="form-check"
                />
                  </th>
                  <th class="data-table-th text-left">通知标题</th>
                  <th class="data-table-th text-left">类型</th>
                  <th class="data-table-th text-left">优先级</th>
                  <th class="data-table-th text-left">推送渠道</th>
                  <th class="data-table-th text-left">状态</th>
                  <th class="data-table-th text-left">接收/已读</th>
                  <th class="data-table-th text-left">发送时间</th>
                  <th class="data-table-th text-left w-36">操作</th>
                </tr>
              </thead>
              <tbody class="data-table-body">
                <tr v-for="item in notificationList" :key="item.id" class="data-table-row">
                  <td class="data-table-td">
                <input
                  type="checkbox"
                  :value="item.id"
                  v-model="selectedList"
                  class="form-check"
                  :disabled="item.publishStatus === 'PUBLISHED'"
                />
                  </td>
                  <td class="data-table-td">
                    <div class="data-table-cell-title">{{ item.title }}</div>
                    <div class="data-table-cell-meta max-w-xs truncate">{{ item.summary || item.content }}</div>
                  </td>
                  <td class="data-table-td">
                    <span class="status-badge" :class="getTypeClass(item.type)">
                  {{ item.typeDesc || getTypeLabel(item.type) }}
                </span>
                  </td>
                  <td class="data-table-td">
                    <span class="status-badge" :class="getPriorityClass(item.priority)">
                  <span class="w-1.5 h-1.5 rounded-full mr-1" :class="getPriorityDotClass(item.priority)"></span>
                  {{ item.priorityDesc || getPriorityLabel(item.priority) }}
                </span>
                  </td>
                  <td class="data-table-td">
                    <div class="flex items-center gap-1 flex-wrap">
                  <span
                    v-for="channel in getPushChannels(item.pushChannels)"
                    :key="channel"
                    class="data-table-inline-tag"
                  >
                    {{ getChannelLabel(channel) }}
                  </span>
                </div>
                  </td>
                  <td class="data-table-td">
                    <span
                  class="status-badge"
                  :class="item.publishStatus === 'PUBLISHED' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'"
                >
                  {{ item.publishStatusDesc || (item.publishStatus === 'PUBLISHED' ? '已发布' : '草稿') }}
                </span>
                  </td>
                  <td class="data-table-td">
                    <div class="text-sm text-slate-600">
                  <span class="text-slate-900">{{ item.totalReceivers || 0 }}</span>
                  <span class="text-slate-400 mx-1">/</span>
                  <span class="text-green-600">{{ item.readCount || 0 }}</span>
                  <span v-if="item.readRate" class="text-xs text-slate-400 ml-1">({{ item.readRate }}%)</span>
                </div>
                  </td>
                  <td class="data-table-td">
                    <div class="text-sm text-slate-500">
                  <div v-if="item.sentTime">{{ item.sentTime }}</div>
                  <div v-else-if="item.scheduleTime" class="text-blue-600">
                    定时: {{ item.scheduleTime }}
                  </div>
                  <div v-else class="text-slate-400">-</div>
                </div>
                  </td>
                  <td class="data-table-td">
                    <div class="flex items-center gap-1">
                  <button
                    @click="viewDetail(item)"
                    class="table-action-button is-primary"
                    title="查看详情" aria-label="查看详情"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                    </svg>
                  </button>
                  <button
                    v-if="item.publishStatus === 'DRAFT'"
                    @click="openNotificationModal(item)"
                    class="table-action-button is-primary"
                    title="编辑" aria-label="编辑"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </button>
                  <button
                    v-if="item.publishStatus === 'DRAFT'"
                    @click="handlePublish(item)"
                    class="table-action-button is-success"
                    title="发布" aria-label="发布"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
                    </svg>
                  </button>
                  <button
                    v-if="item.publishStatus === 'DRAFT'"
                    @click="handleDelete(item.id)"
                    class="table-action-button is-danger"
                    title="删除" aria-label="删除"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </div>
                  </td>
                </tr>
                <tr v-if="notificationList.length === 0 && !loading">
                  <td colspan="9" class="data-table-empty text-slate-500">暂无通知数据</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 分页 -->
        <AppPagination
          v-if="total > 0"
          class="pagination-bridge"
          :current="currentPage"
          :size="pageSize"
          :total="total"
          :pages="totalPages"
          :page-sizes="[10, 20, 50]"
          @page-change="handlePageChange"
          @size-change="handlePageSizeChange"
        />
      </div>
    </div>

    <!-- 新增/编辑通知弹窗 -->
    <div v-if="showModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="fixed inset-0 bg-black/50" @click="closeModal"></div>
      <div class="relative min-h-screen flex items-center justify-center p-4">
        <div class="relative bg-white rounded-xl shadow-2xl overflow-hidden max-w-2xl w-full">
          <div class="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
            <h3 class="text-lg font-semibold text-slate-900">{{ isEdit ? '编辑通知' : '发布通知' }}</h3>
            <button
              @click="closeModal"
              class="p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <div class="p-6 max-h-[70vh] overflow-y-auto">
            <form class="space-y-4">
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">
                    通知类型 <span class="text-red-500">*</span>
                  </label>
                  <el-select
                    v-model="formData.type"
                    class="form-select w-full"
                  >
                    <el-option label="审批通知" value="APPROVAL" />
                    <el-option label="任务通知" value="TASK" />
                    <el-option label="系统通知" value="SYSTEM" />
                    <el-option label="自定义通知" value="CUSTOM" />
                  </el-select>
                </div>
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">
                    优先级 <span class="text-red-500">*</span>
                  </label>
                  <el-select
                    v-model="formData.priority"
                    class="form-select w-full"
                  >
                    <el-option label="普通" value="0" />
                    <el-option label="重要" value="1" />
                    <el-option label="紧急" value="2" />
                  </el-select>
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">
                  通知标题 <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="formData.title"
                  type="text"
                  placeholder="请输入通知标题"
                  class="form-input w-full"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">
                  通知摘要
                </label>
                <input
                  v-model="formData.summary"
                  type="text"
                  placeholder="请输入通知摘要，用于列表展示"
                  class="form-input w-full"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">
                  通知内容 <span class="text-red-500">*</span>
                </label>
                <RichTextEditor v-model="formData.content" placeholder="请输入通知内容..." min-height="250px" upload-module="notification" />
              </div>

              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">
                  推送渠道
                </label>
                <div class="flex flex-wrap gap-3">
                  <label
                    v-for="channel in pushChannelOptions"
                    :key="channel.value"
                    class="flex items-center gap-2 px-3 py-2 border rounded-lg cursor-pointer transition-colors"
                    :class="formData.pushChannels.includes(channel.value) ? 'border-primary-500 bg-primary-50' : 'border-slate-300 hover:bg-slate-50'"
                  >
                    <input
                      type="checkbox"
                      :value="channel.value"
                      v-model="formData.pushChannels"
                      class="form-check"
                    />
                    <span class="text-sm">{{ channel.label }}</span>
                  </label>
                </div>
                <div class="mt-2">
                  <label class="form-switch">
                    <input type="checkbox" v-model="formData.needPush" class="form-switch-input">
                    <span class="form-switch-track"></span>
                    <span class="ml-3 text-sm text-slate-700">同时发送推送通知</span>
                  </label>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">
                    目标用户
                  </label>
                  <el-select
                    v-model="formData.targetType"
                    class="form-select w-full"
                  >
                    <el-option v-for="opt in targetTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                  </el-select>
                </div>
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">
                    定时发送时间
                  </label>
                  <el-date-picker
                    v-model="formData.scheduleTime"
                    type="datetime"
                    format="YYYY年MM月DD日 HH:mm"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    placeholder="请选择发送时间"
                    class="w-full form-date"
                  />
                </div>
              </div>

              <!-- 发布状态开关 -->
              <div class="mt-4">
                <label class="form-switch">
                  <input type="checkbox" v-model="formData.publishNow" class="form-switch-input">
                  <span class="form-switch-track"></span>
                  <span class="ml-3 text-sm text-slate-700">立即发布</span>
                </label>
                <el-text v-if="formData.publishNow" type="success" size="small" class="ml-3">
                  通知将在保存后立即发布
                </el-text>
                <el-text v-else type="info" size="small" class="ml-3">
                  通知将保存为草稿，需手动发布
                </el-text>
              </div>

              <!-- 指定用户选择区域 -->
              <div v-if="formData.targetType !== 'ALL_USER'" class="border-t border-slate-200 pt-4">
                <h4 class="text-sm font-medium text-slate-700 mb-3">选择 {{ getTargetTypeLabel(formData.targetType) }}</h4>

                <!-- 指定加盟商 -->
                <div v-if="formData.targetType === 'TENANT'" class="mb-3">
                  <FranchiseeSelector
                    v-model="formData.tenantIds"
                    multiple
                    placeholder="请选择加盟商"
                  />
                </div>

                <!-- 指定角色 -->
                <div v-if="formData.targetType === 'ROLE'" class="mb-3">
                  <RoleSelector
                    v-model="formData.roleIds"
                    multiple
                    placeholder="请选择角色"
                  />
                </div>

                <!-- 指定部门 -->
                <div v-if="formData.targetType === 'DEPT'" class="mb-3">
                  <DeptSelector
                    v-model="formData.deptIds"
                    multiple
                    placeholder="请选择部门"
                  />
                </div>

                <!-- 指定用户 -->
                <div v-if="formData.targetType === 'USER_LIST'" class="mb-3">
                  <UserSelector
                    v-model="formData.userIds"
                    multiple
                    placeholder="请选择用户"
                  />
                </div>

                <el-text v-if="getSelectedCount() === 0" type="warning" size="small">
                  请至少选择一个{{ getTargetTypeLabel(formData.targetType) }}
                </el-text>
              </div>

              <!-- 跳转配置 -->
              <div class="border-t border-slate-200 pt-4">
                <h4 class="text-sm font-medium text-slate-700 mb-3">跳转配置</h4>
                <div class="grid grid-cols-2 gap-4">
                  <div>
                    <label class="block text-xs font-medium text-slate-700 mb-1">跳转类型</label>
                    <el-select
                      v-model="formData.link.linkType"
                      class="form-select w-full"
                    >
                      <el-option label="无跳转" value="" />
                      <el-option label="订单详情" value="ORDER" />
                      <el-option label="审批详情" value="APPROVAL" />
                      <el-option label="客户详情" value="CUSTOMER" />
                      <el-option label="合同详情" value="CONTRACT" />
                      <el-option label="日程详情" value="SCHEDULE" />
                      <el-option label="待办事项" value="TODO" />
                      <el-option label="表单页面" value="FORM" />
                      <el-option label="外部链接" value="WEB_URL" />
                      <el-option label="自定义页面" value="CUSTOM" />
                    </el-select>
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-slate-700 mb-1">业务ID</label>
                    <input
                      v-model="formData.link.businessId"
                      type="text"
                      placeholder="请输入业务ID"
                      class="form-input w-full"
                    />
                  </div>
                </div>
                <div v-if="formData.link.linkType === 'WEB_URL'" class="mt-3">
                  <label class="block text-xs font-medium text-slate-700 mb-1">完整URL</label>
                  <input
                    v-model="formData.link.webUrl"
                    type="text"
                    placeholder="https://example.com"
                    class="form-input w-full"
                  />
                </div>
                <div v-if="formData.link.linkType && formData.link.linkType !== 'WEB_URL'" class="mt-3">
                  <label class="form-switch">
                    <input type="checkbox" v-model="formData.link.webNewWindow" class="form-switch-input">
                    <span class="form-switch-track"></span>
                    <span class="ml-3 text-sm text-slate-700">新窗口打开</span>
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div class="px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3">
            <button
              @click="closeModal"
              class="btn-secondary"
            >
              取消
            </button>
            <button
              @click="handleSave"
              :disabled="saving"
              class="btn-primary"
            >
              {{ saving ? '保存中...' : (isEdit ? '保存' : '发布') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <div v-if="showDetailModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="fixed inset-0 bg-black/50" @click="showDetailModal = false"></div>
      <div class="relative min-h-screen flex items-center justify-center p-4">
        <div class="relative bg-white rounded-xl shadow-2xl overflow-hidden max-w-2xl w-full">
          <div class="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
            <h3 class="text-lg font-semibold text-slate-900">通知详情</h3>
            <button
              @click="showDetailModal = false"
              class="p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <div class="p-6 max-h-[70vh] overflow-y-auto">
            <div class="space-y-4">
              <div class="flex items-center gap-3">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium" :class="getTypeClass(currentDetail?.type)">
                  {{ currentDetail?.typeDesc || getTypeLabel(currentDetail?.type) }}
                </span>
                <span class="status-badge" :class="getPriorityClass(currentDetail?.priority)">
                  {{ currentDetail?.priorityDesc || getPriorityLabel(currentDetail?.priority) }}
                </span>
                <span
                  class="status-badge"
                  :class="currentDetail?.publishStatus === 'PUBLISHED' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'"
                >
                  {{ currentDetail?.publishStatusDesc }}
                </span>
              </div>

              <div>
                <h4 class="text-lg font-semibold text-slate-800">{{ currentDetail?.title }}</h4>
                <p class="text-sm text-slate-500 mt-1">{{ currentDetail?.summary }}</p>
              </div>

              <div class="border-t border-slate-200 pt-4">
                <h5 class="text-sm font-medium text-slate-700 mb-2">通知内容</h5>
                <div class="p-4 bg-slate-50 rounded-lg text-sm text-slate-800 whitespace-pre-wrap">{{ currentDetail?.content }}</div>
              </div>

              <div class="grid grid-cols-2 gap-4 border-t border-slate-200 pt-4">
                <div>
                  <span class="text-sm text-slate-500">发送时间</span>
                  <p class="text-sm text-slate-800 mt-1">{{ currentDetail?.sentTime || (currentDetail?.scheduleTime ? `定时: ${currentDetail.scheduleTime}` : '-') }}</p>
                </div>
                <div>
                  <span class="text-sm text-slate-500">创建时间</span>
                  <p class="text-sm text-slate-800 mt-1">{{ currentDetail?.createTime || '-' }}</p>
                </div>
                <div>
                  <span class="text-sm text-slate-500">接收人数</span>
                  <p class="text-sm text-slate-800 mt-1">{{ currentDetail?.totalReceivers || 0 }}</p>
                </div>
                <div>
                  <span class="text-sm text-slate-500">已读人数</span>
                  <p class="text-sm text-slate-800 mt-1">{{ currentDetail?.readCount || 0 }} ({{ currentDetail?.readRate || 0 }}%)</p>
                </div>
              </div>

              <div v-if="currentDetail?.linkType && currentDetail.linkType !== 'NONE'" class="border-t border-slate-200 pt-4">
                <h5 class="text-sm font-medium text-slate-700 mb-2">跳转配置</h5>
                <div class="text-sm text-slate-600 space-y-1">
                  <p>跳转类型：{{ currentDetail.linkType }}</p>
                  <p v-if="currentDetail.businessId">业务ID：{{ currentDetail.businessId }}</p>
                  <p v-if="currentDetail.webPath">Web路径：{{ currentDetail.webPath }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-4 border-t border-slate-200 flex justify-end">
            <button
              @click="showDetailModal = false"
              class="btn-secondary"
            >
              关闭
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 发布确认弹窗 -->
    <div v-if="showPublishModal" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="fixed inset-0 bg-black/50" @click="showPublishModal = false"></div>
      <div class="relative min-h-screen flex items-center justify-center p-4">
        <div class="bg-white rounded-xl shadow-2xl p-6 max-w-md mx-4">
          <div class="flex items-center gap-4 mb-4">
            <div class="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
              <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-slate-900">发布通知</h3>
              <p class="text-sm text-slate-500">确定要发布该通知吗？发布后将无法修改和删除。</p>
            </div>
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-slate-700 mb-1">目标用户</label>
            <el-select
              v-model="publishTarget.targetType"
              class="form-select w-full"
            >
              <el-option v-for="opt in targetTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
          </div>

          <!-- 发布时的指定用户选择区域 -->
          <div v-if="publishTarget.targetType !== 'ALL_USER'" class="mb-4">
            <label class="block text-sm font-medium text-slate-700 mb-1">
              选择 {{ getTargetTypeLabel(publishTarget.targetType) }}
            </label>

            <!-- 指定加盟商 -->
            <div v-if="publishTarget.targetType === 'TENANT'">
              <FranchiseeSelector
                v-model="publishTarget.tenantIds"
                multiple
                placeholder="请选择加盟商"
              />
            </div>

            <!-- 指定角色 -->
            <div v-if="publishTarget.targetType === 'ROLE'">
              <RoleSelector
                v-model="publishTarget.roleIds"
                multiple
                placeholder="请选择角色"
              />
            </div>

            <!-- 指定部门 -->
            <div v-if="publishTarget.targetType === 'DEPT'">
              <DeptSelector
                v-model="publishTarget.deptIds"
                multiple
                placeholder="请选择部门"
              />
            </div>

            <!-- 指定用户 -->
            <div v-if="publishTarget.targetType === 'USER_LIST'">
              <UserSelector
                v-model="publishTarget.userIds"
                multiple
                placeholder="请选择用户"
              />
            </div>

            <el-text v-if="publishTarget.targetType === 'TENANT' && (!publishTarget.tenantIds || publishTarget.tenantIds.length === 0)" type="warning" size="small">
              请至少选择一个加盟商
            </el-text>
            <el-text v-if="publishTarget.targetType === 'ROLE' && (!publishTarget.roleIds || publishTarget.roleIds.length === 0)" type="warning" size="small">
              请至少选择一个角色
            </el-text>
            <el-text v-if="publishTarget.targetType === 'DEPT' && (!publishTarget.deptIds || publishTarget.deptIds.length === 0)" type="warning" size="small">
              请至少选择一个部门
            </el-text>
            <el-text v-if="publishTarget.targetType === 'USER_LIST' && (!publishTarget.userIds || publishTarget.userIds.length === 0)" type="warning" size="small">
              请至少选择一个用户
            </el-text>
          </div>

          <div class="flex items-center justify-end gap-3">
            <button
              @click="showPublishModal = false"
              class="btn-secondary"
            >
              取消
            </button>
            <button
              @click="confirmPublish"
              :disabled="publishing"
              class="btn-primary"
            >
              {{ publishing ? '发布中...' : '确认发布' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import RichTextEditor from '@/components/RichTextEditor.vue'
import AppPagination from '@/components/AppPagination.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import {
  getNotificationList,
  getNotificationDetail,
  createNotification,
  updateNotification,
  deleteNotification,
  updatePublishStatus
} from '@/api/notification'

// 引入选择器组件
import FranchiseeSelector from '@/components/FranchiseeSelector/index.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'
import RoleSelector from './components/RoleSelector/index.vue'
import DeptSelector from './components/DeptSelector/index.vue'
import UserSelector from '@/components/UserSelector/index.vue'

const loading = ref(false)
const saving = ref(false)
const publishing = ref(false)
const showModal = ref(false)
const showDetailModal = ref(false)
const showPublishModal = ref(false)
const isEdit = ref(false)
const currentDetail = ref(null)
const currentNotification = ref(null)

const notificationList = ref([])
const selectedList = ref([])
const selectAll = ref(false)

const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const totalPages = ref(1)

const searchForm = reactive({
  type: '',
  priority: '',
  publishStatus: ''
})

const formData = reactive({
  id: null,
  type: 'SYSTEM',
  title: '',
  summary: '',
  content: '',
  priority: 0,
  needPush: false,
  pushChannels: [],
  scheduleTime: '',
  publishNow: false,
  targetType: 'ALL_USER',
  tenantIds: [],
  roleIds: [],
  deptIds: [],
  userIds: [],
  link: {
    linkType: '',
    businessId: '',
    webUrl: '',
    webNewWindow: false
  }
})

const publishTarget = reactive({
  targetType: 'ALL_USER',
  tenantIds: [],
  roleIds: [],
  deptIds: [],
  userIds: []
})

// 目标用户类型选项
const targetTypeOptions = [
  { value: 'ALL_USER', label: '全体用户' },
  { value: 'TENANT', label: '指定加盟商' },
  { value: 'ROLE', label: '指定角色' },
  { value: 'DEPT', label: '指定部门' },
  { value: 'USER_LIST', label: '指定用户' }
]

function getTargetTypeLabel(type) {
  const opt = targetTypeOptions.find(o => o.value === type)
  return opt ? opt.label : ''
}

// 从对象数组中提取ID列表
function extractIds(arr) {
  if (!arr || !Array.isArray(arr)) return []
  return arr.map(item => {
    if (typeof item === 'object' && item.id != null) {
      return item.id
    }
    return item
  })
}

function getSelectedCount() {
  switch (formData.targetType) {
    case 'TENANT':
      return formData.tenantIds?.length || 0
    case 'ROLE':
      return formData.roleIds?.length || 0
    case 'DEPT':
      return formData.deptIds?.length || 0
    case 'USER_LIST':
      return formData.userIds?.length || 0
    default:
      return 0
  }
}

const pushChannelOptions = [
  { value: 'EMAIL', label: '邮件' },
  { value: 'SMS', label: '短信' },
  { value: 'DINGTALK', label: '钉钉' }
]

function getTypeClass(type) {
  const classMap = {
    APPROVAL: 'bg-amber-100 text-amber-800',
    TASK: 'bg-purple-100 text-purple-800',
    SYSTEM: 'bg-blue-100 text-blue-800',
    CUSTOM: 'bg-green-100 text-green-800'
  }
  return classMap[type] || 'bg-slate-100 text-slate-800'
}

function getTypeLabel(type) {
  const labelMap = {
    APPROVAL: '审批通知',
    TASK: '任务通知',
    SYSTEM: '系统通知',
    CUSTOM: '自定义通知'
  }
  return labelMap[type] || type
}

function getPriorityClass(priority) {
  const classMap = {
    0: 'bg-slate-100 text-slate-700',
    1: 'bg-amber-100 text-amber-700',
    2: 'bg-red-100 text-red-700'
  }
  return classMap[priority] || 'bg-slate-100 text-slate-700'
}

function getPriorityDotClass(priority) {
  const classMap = {
    0: 'bg-slate-400',
    1: 'bg-amber-500',
    2: 'bg-red-500'
  }
  return classMap[priority] || 'bg-slate-400'
}

function getPriorityLabel(priority) {
  const labelMap = {
    0: '普通',
    1: '重要',
    2: '紧急'
  }
  return labelMap[priority] || '普通'
}

function getChannelLabel(channel) {
  const labelMap = {
    EMAIL: '邮件',
    SMS: '短信',
    DINGTALK: '钉钉',
    inapp: '站内信'
  }
  return labelMap[channel] || channel
}

function getPushChannels(channels) {
  if (!channels) return []
  if (Array.isArray(channels)) return channels
  return channels.split(',').filter(c => c)
}

function handleSelectAll() {
  if (selectAll.value) {
    selectedList.value = notificationList.value
      .filter(item => item.publishStatus !== 'PUBLISHED')
      .map(item => item.id)
  } else {
    selectedList.value = []
  }
}

async function loadNotifications() {
  try {
    loading.value = true
    const params = {
      pageNum: currentPage.value,
      pageSize: pageSize.value
    }
    if (searchForm.type) params.type = searchForm.type
    if (searchForm.priority !== '') params.priority = parseInt(searchForm.priority)
    if (searchForm.publishStatus !== '') params.publishStatus = parseInt(searchForm.publishStatus)

    const res = await getNotificationList(params)
    notificationList.value = res.records || []
    total.value = res.total || 0
    totalPages.value = res.pages || 1
  } catch (error) {
    console.error('加载通知列表失败:', error)
    ElMessage.error(error.message || '加载通知列表失败')
  } finally {
    loading.value = false
  }
}

function handleSearch() {
  currentPage.value = 1
  loadNotifications()
}

function resetSearch() {
  searchForm.type = ''
  searchForm.priority = ''
  searchForm.publishStatus = ''
  handleSearch()
}

function handlePageChange(page) {
  currentPage.value = page
  loadNotifications()
}

function handlePageSizeChange(size) {
  pageSize.value = size
  currentPage.value = 1
  loadNotifications()
}

function openNotificationModal(notification = null) {
  if (notification) {
    isEdit.value = true
    formData.id = notification.id
    formData.type = notification.type
    formData.title = notification.title
    formData.summary = notification.summary || ''
    formData.content = notification.content
    formData.priority = notification.priority
    formData.needPush = notification.needPush || false
    formData.pushChannels = getPushChannels(notification.pushChannels)
    formData.scheduleTime = notification.scheduleTime ? notification.scheduleTime.slice(0, 16) : ''
    formData.targetType = notification.target?.targetType || 'ALL_USER'
    formData.tenantIds = notification.target?.tenantIds || []
    formData.roleIds = notification.target?.roleIds || []
    formData.deptIds = notification.target?.deptIds || []
    formData.userIds = notification.target?.userIds || []
    formData.link = {
      linkType: notification.linkType || '',
      businessId: notification.businessId || '',
      webUrl: notification.webUrl || '',
      webNewWindow: notification.webNewWindow || false
    }
  } else {
    isEdit.value = false
    formData.id = null
    formData.type = 'SYSTEM'
    formData.title = ''
    formData.summary = ''
    formData.content = ''
    formData.priority = 0
    formData.needPush = false
    formData.pushChannels = []
    formData.scheduleTime = ''
    formData.publishNow = false
    formData.targetType = 'ALL_USER'
    formData.tenantIds = []
    formData.roleIds = []
    formData.deptIds = []
    formData.userIds = []
    formData.link = {
      linkType: '',
      businessId: '',
      webUrl: '',
      webNewWindow: false
    }
  }
  showModal.value = true
}

function closeModal() {
  showModal.value = false
}

async function handleSave() {
  if (!formData.title.trim()) {
    ElMessage.warning('请输入通知标题')
    return
  }
  if (!formData.content || !formData.content.trim()) {
    ElMessage.warning('请输入通知内容')
    return
  }
  // 验证目标用户选择
  if (formData.targetType !== 'ALL_USER' && getSelectedCount() === 0) {
    ElMessage.warning(`请至少选择一个${getTargetTypeLabel(formData.targetType)}`)
    return
  }

  try {
    saving.value = true
    const data = {
      type: formData.type,
      publishStatus: formData.publishNow ? 1 : 0,
      title: formData.title,
      content: formData.content,
      summary: formData.summary,
      priority: parseInt(formData.priority),
      needPush: formData.needPush,
      pushChannels: formData.pushChannels.join(','),
      scheduleTime: formData.scheduleTime ? new Date(formData.scheduleTime).toISOString() : '',
      target: {
        targetType: formData.targetType,
        tenantIds: formData.targetType === 'TENANT' ? extractIds(formData.tenantIds) : [],
        roleIds: formData.targetType === 'ROLE' ? extractIds(formData.roleIds) : [],
        deptIds: formData.targetType === 'DEPT' ? extractIds(formData.deptIds) : [],
        userIds: formData.targetType === 'USER_LIST' ? extractIds(formData.userIds) : []
      },
      link: {
        linkType: formData.link.linkType || null,
        businessId: formData.link.businessId || null,
        webPath: formData.link.webUrl || null,
        webNewWindow: formData.link.webNewWindow || false
      }
    }

    if (isEdit.value) {
      await updateNotification(formData.id, data)
      ElMessage.success('更新成功')
    } else {
      await createNotification(data)
      ElMessage.success('创建成功')
    }

    closeModal()
    loadNotifications()
  } catch (error) {
    console.error('保存通知失败:', error)
    ElMessage.error(error.message || '保存通知失败')
  } finally {
    saving.value = false
  }
}

async function handleDelete(id) {
  if (!confirm('确定要删除该通知吗？删除后无法恢复。')) return

  try {
    await deleteNotification(id)
    ElMessage.success('删除成功')
    loadNotifications()
  } catch (error) {
    console.error('删除通知失败:', error)
    ElMessage.error(error.message || '删除通知失败')
  }
}

async function handleBatchDelete() {
  if (selectedList.value.length === 0) {
    ElMessage.warning('请选择要删除的通知')
    return
  }

  if (!confirm(`确定要删除选中的 ${selectedList.value.length} 条通知吗？`)) return

  try {
    await Promise.all(selectedList.value.map(id => deleteNotification(id)))
    ElMessage.success('批量删除成功')
    selectedList.value = []
    selectAll.value = false
    loadNotifications()
  } catch (error) {
    console.error('批量删除失败:', error)
    ElMessage.error(error.message || '批量删除失败')
  }
}

function handlePublish(notification) {
  currentNotification.value = notification
  publishTarget.targetType = 'ALL_USER'
  publishTarget.tenantIds = []
  publishTarget.roleIds = []
  publishTarget.deptIds = []
  publishTarget.userIds = []
  showPublishModal.value = true
}

async function confirmPublish() {
  // 验证目标用户选择
  if (publishTarget.targetType !== 'ALL_USER') {
    const hasSelection =
      (publishTarget.targetType === 'TENANT' && publishTarget.tenantIds?.length > 0) ||
      (publishTarget.targetType === 'ROLE' && publishTarget.roleIds?.length > 0) ||
      (publishTarget.targetType === 'DEPT' && publishTarget.deptIds?.length > 0) ||
      (publishTarget.targetType === 'USER_LIST' && publishTarget.userIds?.length > 0)
    if (!hasSelection) {
      ElMessage.warning(`请至少选择一个${getTargetTypeLabel(publishTarget.targetType)}`)
      return
    }
  }

  try {
    publishing.value = true
    await updatePublishStatus(currentNotification.value.id, {
      id: currentNotification.value.id,
      publishStatus: 1,
      target: {
        targetType: publishTarget.targetType,
        tenantIds: publishTarget.targetType === 'TENANT' ? extractIds(publishTarget.tenantIds) : [],
        roleIds: publishTarget.targetType === 'ROLE' ? extractIds(publishTarget.roleIds) : [],
        deptIds: publishTarget.targetType === 'DEPT' ? extractIds(publishTarget.deptIds) : [],
        userIds: publishTarget.targetType === 'USER_LIST' ? extractIds(publishTarget.userIds) : []
      }
    })
    ElMessage.success('发布成功')
    showPublishModal.value = false
    loadNotifications()
  } catch (error) {
    console.error('发布通知失败:', error)
    ElMessage.error(error.message || '发布通知失败')
  } finally {
    publishing.value = false
  }
}

async function viewDetail(notification) {
  try {
    const res = await getNotificationDetail(notification.id)
    currentDetail.value = res
    showDetailModal.value = true
  } catch (error) {
    console.error('获取通知详情失败:', error)
    ElMessage.error(error.message || '获取通知详情失败')
  }
}

onMounted(() => {
  loadNotifications()
})
</script>
